import { useNavigate } from "react-router-dom";

import { BidFavoriteContent, BidFavoriteFilter } from "@/types/bid";

import { BidTypeCd } from "@/consts/Bid";

import { isNotEmpty, getDate } from "@/libs/utils";

import { DeleteFavoriteBid } from "@/services/Bid";

import CommonImg from "@/components/Common/Img";
import CommonInput from "@/components/Common/Input";
import CommonSelect from "@/components/Common/Select";
import DDayBadge from "@/components/DDayBadge";
import CommonButton from "@/components/Common/Button";

import SortIcon from "@/assets/images/sort-icon.svg";
import DeleteIcon from "@/assets/images/delete-icon.svg";

type Props = {
  content: BidFavoriteContent;
  onSearch: (searchFilter: BidFavoriteFilter) => void;
  filter: BidFavoriteFilter;
  setFilter: React.Dispatch<React.SetStateAction<BidFavoriteFilter>>;
};
export default function BidFavoriteList({
  content,
  onSearch,
  filter,
  setFilter,
}: Props) {
  const navigate = useNavigate();
  const handleClickDeleteFavorite = async (project_id: string) => {
    try {
      const result = await DeleteFavoriteBid(filter.project_type, project_id);
      if (result.data.success) {
        onSearch(filter);
      } else {
        alert(result.data.error.content);
      }
    } catch (e) {
    } finally {
    }
  };

  const handleChangeFilter = (value: string, prop: string) => {
    setFilter((prev) => {
      const newFilter = { ...prev, [prop]: value };
      onSearch(newFilter);
      return newFilter;
    });
  };

  const handleSortFilter = (prop: string) => {
    setFilter((prev) => {
      const newFilter = {
        ...prev,
        sort_by: prop,
        order: prev.order === "desc" ? "asc" : "desc",
      };
      onSearch(newFilter);
      return newFilter;
    });
  };

  return (
    <div className="bg-white flex flex-col rounded-[8px] border-[1px] border-gray-D">
      <div className="p-[14px] flex justify-between">
        <div className="flex gap-[8px]">
          <CommonInput
            defaultValue={filter.title}
            onKeyDownEnter={(value: string) => {
              handleChangeFilter(value, "title");
            }}
            onChange={(value: string) => {
              setFilter((prev) => ({ ...prev, title: value }));
            }}
            placeholder="공고명 검색"
          />
          <CommonInput
            defaultValue={filter.dminst_filter}
            onKeyDownEnter={(value: string) => {
              handleChangeFilter(value, "dminst_filter");
            }}
            onChange={(value: string) => {
              setFilter((prev) => ({ ...prev, dminst_filter: value }));
            }}
            placeholder="기관 검색"
          />
          <CommonSelect
            defaultValue={filter.category}
            optionList={[
              { label: "용역", value: "TYPE_01" },
              { label: "물품", value: "TYPE_02" },
              { label: "공사", value: "TYPE_03" },
              { label: "외자", value: "TYPE_04" },
              { label: "기타", value: "TYPE_05" },
            ]}
            onChange={(value: string) => {
              handleChangeFilter(value, "category");
            }}
          />
        </div>
        <div>
          <CommonButton
            label="검색하기"
            onClick={() => {
              onSearch(filter);
            }}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <table>
          <colgroup>
            <col width="5%" />
            <col width="30%" />
            <col width="10%" />
            <col width="15%" />
            <col width="15%" />
            <col width="20%" />
            <col width="5%" />
          </colgroup>
          <thead>
            <tr className="h-[30px] bg-dark-brown text-white text-[12px] font-semibold">
              <th>구분</th>
              <th className="text-left">공고명</th>
              <th className="">
                <div
                  className="flex gap-[4px] justify-center items-center cursor-pointer"
                  onClick={() => {
                    handleSortFilter("budget_amount");
                  }}
                >
                  금액
                  <CommonImg src={SortIcon} alt="Sort" />
                </div>
              </th>
              <th>공고기관</th>
              <th>
                <div
                  className="flex gap-[4px] justify-center items-center cursor-pointer"
                  onClick={() => {
                    handleSortFilter("uploaded_dt");
                  }}
                >
                  게시일
                  <CommonImg src={SortIcon} alt="Sort" />
                </div>
              </th>
              <th>
                <div
                  className="flex gap-[4px] justify-center items-center cursor-pointer"
                  onClick={() => {
                    handleSortFilter("close_dt");
                  }}
                >
                  마감일
                  <CommonImg src={SortIcon} alt="Sort" />
                </div>
              </th>
              <th>삭제</th>
            </tr>
          </thead>
          <tbody>
            {content.items &&
              content.items.map((item, itemIndex) => (
                <tr
                  key={itemIndex}
                  className="px-[20px] py-[10px] border-t-2 border-gray-D text-center text-[12px] font-normal"
                >
                  <td className="px-[20px] py-[14px]">
                    {BidTypeCd[item.category]}
                  </td>
                  <td
                    className="text-left cursor-pointer"
                    onClick={() => {
                      navigate(
                        `/bid/domestic/detail/${filter.project_type}/${item.project_id}`
                      );
                    }}
                  >
                    {item.title}
                  </td>
                  <td className="px-[20px] py-[14px]">
                    {isNotEmpty(item.budget_amount)
                      ? item.budget_amount.toLocaleString()
                      : "공고서 참조"}
                  </td>
                  <td className="px-[20px] py-[14px]">{item.dminst_nm}</td>
                  <td className="px-[20px] py-[14px]">
                    {getDate(item.uploaded_dt)}
                  </td>
                  <td className="px-[20px] py-[14px]">
                    {isNotEmpty(item.close_dt) && (
                      <div className="flex items-center justify-center">
                        {getDate(item.close_dt)}
                        <DDayBadge targetDate={item.close_dt} />
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="flex justify-center">
                      <CommonImg
                        src={DeleteIcon}
                        alt="Delete"
                        className="cursor-pointer"
                        onClick={() => {
                          handleClickDeleteFavorite(item.project_id);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
